import { useEffect } from 'react'
import { useThemeStore, applyTheme } from '@/store/themeStore'

/**
 * Call once at the app root. Applies the theme class to <html> and
 * listens for OS-level changes when theme is set to 'system'.
 */
export function useThemeSync() {
  const theme = useThemeStore((s) => s.theme)

  useEffect(() => {
    applyTheme(theme)

    if (theme !== 'system') return

    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const handler = () => applyTheme('system')
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [theme])
}
